import { AuditLogScreen } from "~/session/audit/audit-log-screen";

// `/session/:id/audit` (E8.2): the v1 audit-log viewer. Visible to any ward
// member; the API's `WardMembershipGuard` is authoritative for access. Rendered
// inside <SessionLayout> so the session and ward header sit above the timeline.
export default function SessionAuditRoute(): JSX.Element {
  return <AuditLogScreen />;
}
